import config from "config/config.js";

const login = body => {
  const endpoint = `${config.baseUrl}/api/authentication/login`;
  const options = {
    method: "post",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(body)
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      console.log("ressssss", res);
      if (res && res.accessToken && res.xsrfToken) {
        localStorage.setItem("xsrfToken", JSON.stringify(res.xsrfToken));
        localStorage.setItem("accessToken", JSON.stringify(res.accessToken));

        return res;
      }
      if (res.error && res.error.status) {
        if (res.error.status === 401) {
          console.log("error 401");
          return 401;
        } else {
          console.log("generic error");
          return res.error.status;
        }
      }
      window.location.href = config.clientUrl;
      return null;
      // return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default login;
